import { Directive } from '@angular/core';
import { AbstractControlOptions, Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import * as _ from 'lodash';

@Directive()
export abstract class PrBankResourcesFormBuilder extends PrFormAbstract {
  generate(entity: any) {
    console.log({ entity });

    let options: AbstractControlOptions = {};
    return this.formBuilder.group(
      {
        id: [entity ? entity.id : null],
        productType: [entity ? entity.productType : null, Validators.required],
        managerProviderId: [
          entity ? entity.managerProviderId : null,
          Validators.nullValidator,
        ],
        label: [entity ? entity.label : null, Validators.required],
        lastValue: [entity ? entity.lastValue : null, Validators.required],
        monthlyPayment: [
          entity ? entity.monthlyPayment : null,
          Validators.nullValidator,
        ],
        startDate: [
          entity?.startDate ? entity.startDate : new Date(),
          Validators.required,
        ],
        subscriptionSource: [
          entity?.subscriptionSource ? entity.subscriptionSource : 'BANK',
          Validators.required,
        ],
        subscriptionId: [entity ? entity.subscriptionId : null],
        accountId: [entity ? entity.accountId : null],
        userId: [entity ? entity.userId : null, Validators.required],
        owners: [this.buildInitialOwners(entity), Validators.required],
      },
      options,
    );
  }

  extract() {
    let dto: any = {
      id: this.emptyIsNull(this.form.value.id),
      type: this.emptyIsNull(this.form.value.productType),
      label: this.emptyIsNull(this.form.value.label),
      lastValue: this.emptyIsNull(this.form.value.lastValue),
      monthlyPayment: this.emptyIsNull(this.form.value.monthlyPayment),
      startDate:
        new Date(this.form.value.startDate).toISOString().split('.')[0] + 'Z',
      managerProviderId: this.emptyIsNull(
        this.form.value.managerProviderId?.id,
      ),
      subLabel: this.emptyIsNull(this.form.value.managerProviderId?.name),
      subscriptionSource: this.emptyIsNull(this.form.value.subscriptionSource),
      subscriptionId: this.emptyIsNull(this.form.value.subscriptionId),
      accountId: this.emptyIsNull(this.form.value.accountId),
      userId: this.emptyIsNull(this.form.value.userId),
      owners: this.form.value.owners,
    };
    return dto;
  }
}
